import { Button, Container, Link, Stack, Typography, Box } from "@mui/material";
import React from "react";
import {
  ThemeProvider,
  createTheme,
  Theme,
  responsiveFontSizes,
} from "@mui/material/styles";
import { getFirstMenuSegment } from "../../../utils/url";
import FacebookIcon from "../../../assets/svgs/some/facebook.svg";
import InstagramIcon from "../../../assets/svgs/some/instagram.svg";
import YouTubeIcon from "../../../assets/svgs/some/youtube.svg";
import SpotifyIcon from "../../../assets/svgs/some/spotify.svg";
import TikTokIcon from "../../../assets/svgs/some/tiktok.svg";
import ApplePodcast from "../../../assets/svgs/some/applepodcast.svg";
import Podimo from "../../../assets/svgs/some/podimo.svg";
import COLORS from "../../../constants/colors";
import ArrowSquareOut from "../../../assets/svgs/some/arrowsquareout.svg";
import FinansAut from "../../../assets/svgs/finaut-logo.svg";
import FinansTilsynet from "../../../assets/svgs/ft-logo.svg";

const Shortcuts = [
  // TODO gege
  {
    title: "Ambassadører",
    url: "/ambassadorer",
  },

  {
    title: "Banker",
    url: "/samarbeidsbanker",
  },

  {
    title: "Dealspartnere",
    url: "/dealspartnere",
  },
];

const HordePageFooter = () => {
  const currentPath = getFirstMenuSegment();

  // Footer theme
  const footerTheme = (mainTheme: Theme) =>
    responsiveFontSizes(
      createTheme({
        typography: {
          ...mainTheme.typography,
          h3: {
            fontSize: 24,
            fontWeight: 500,
            lineHeight: 1.25,
          },
          h4: {
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.25,
          },
          body1: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.6,
          },
        },
        components: {
          ...mainTheme.components,
          MuiContainer: {
            ...mainTheme.components?.MuiContainer,
            styleOverrides: {
              ...mainTheme.components?.MuiContainer?.styleOverrides,
              root: {
                paddingTop: 60,
                paddingBottom: 50,
                [mainTheme.breakpoints.down("md")]: {
                  paddingTop: 20,
                  paddingBottom: 40,
                },
                "& nav ul": {
                  listStyleType: "none",
                  padding: 0,
                  margin: 0,
                  "& .MuiLink-root": {
                    marginLeft: -6,
                  },
                  "& li": {
                    marginTop: 16,
                  },
                },
                "& .someList": {
                  "& li": {
                    marginTop: 8,
                  },
                },
                "& address .MuiLink-root": {
                  marginLeft: -6,
                },
                "& a": {
                  whiteSpace: "nowrap",
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: 1.5,
                  "&:hover": {
                    textDecoration: "underline",
                  },
                },
                "& p": {
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: 1.5,
                },
                "& address": {
                  fontStyle: "normal",
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                },
                "& a.Mui-focusVisible": {
                  color: mainTheme.palette.primary.main,
                  backgroundColor: "#ffffff",
                  borderRadius: 4,
                  textDecoration: "underline",
                  outline: "none",
                  "& svg": {
                    fill: mainTheme.palette.primary.main,
                  },
                },

                "& .someLink": {
                  display: "flex",
                  alignItems: "center",
                  "& svg": {
                    marginRight: 16,
                  },
                },
                "& label": {
                  color: mainTheme.palette.text.primary,
                },
              },
            },
          },
        },
      })
    );

  return (
    <ThemeProvider theme={footerTheme}>
      <footer>
        <Container
          maxWidth={false} // Deaktiver standard maxWidth
          sx={{
            maxWidth: "1350px",
            margin: "0 auto",
          }}
        >
          <Stack>
            <Stack direction={{ xs: "column", md: "row" }}>
              <Stack flexShrink={1}>
                <Stack>
                  <Typography variant="h3" marginRight="30px">
                    Sjekk om du får bedre lån
                  </Typography>
                  <Stack component="section">
                    <Typography
                      variant="body1"
                      sx={{
                        maxWidth: "400px",
                        paddingTop: "25px",
                        marginRight: "30px",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        aria-label=""
                        type="submit"
                        sx={{
                          maxWidth: "400px",
                          marginBottom: "29px",
                          marginTop: { xs: "20px", md: "0px" },
                          textDecoration: "none !important",
                          fontSize: "16px !important",
                          fontWeight: "600 !important",
                          "&:hover": {
                            backgroundColor: COLORS.BLACK[40], // Endre til ønsket hover-farge
                          },
                          "&:focus": {
                            borderRadius: "40px !important",
                          },
                        }}
                        href="https://web.horde.no/refinansiering/gjeldsregister"
                      >
                        Søk refinansiering
                      </Button>
                      <Typography variant="body1" marginRight="0px">
                        Renteeksempel refinansiering: 135 000 kr over 8 år,
                        effektiv rente 14,73 %, kostnad 85 376 kr,
                        <Box
                          component="span"
                          sx={{
                            display: { xs: "inline", md: "none" },
                          }}
                        >
                          <br />
                        </Box>
                        totalt 220 376 kr, nedbetalingstid 0-15 år.{" "}
                      </Typography>
                    </Typography>
                  </Stack>
                </Stack>
                {/* <NewsLetterInput /> */}
              </Stack>
              <Stack
                direction={{ xs: "column", md: "row" }}
                gap={{ xs: "32x", md: "20px" }}
                marginLeft={{ xs: "0px", md: "60px" }}
                flexGrow={1}
                justifyContent="flex-end"
              >
                <Stack
                  gap={{ xs: "32px", md: "65px" }}
                  flexGrow={1}
                  flexShrink={1}
                  flexBasis="auto"
                >
                  <Stack
                    component="section"
                    paddingTop={{ xs: "15px", md: "0px" }}
                  >
                    <nav aria-labelledby="footer_shortcuts">
                      <Typography
                        variant="h4"
                        id="footer_shortcuts"
                        marginTop={{ xs: "30px", md: "0px" }}
                      >
                        Partnere
                      </Typography>
                      <ul>
                        {Shortcuts.map((item, index) => {
                          return (
                            <li key={index}>
                              <Link
                                color="secondary"
                                href={item.url}
                                aria-current={currentPath === item.url}
                              >
                                {item.title}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </nav>
                  </Stack>
                  <Stack
                    component="section"
                    paddingTop={{ xs: "15px", md: "20px" }}
                  >
                    <nav aria-labelledby="footer_hordePlus">
                      <Typography variant="h4" id="footer_hordePlus">
                        Hjelp og info
                      </Typography>
                      <ul>
                        <li>
                          <Link href="/spoersmal-og-svar" color="secondary">
                            Spørsmål og svar
                          </Link>
                          <li>
                            <Link
                              href="https://horde.no/rewards"
                              color="secondary"
                              marginBottom={{ xs: "10px", md: "0px" }}
                            >
                              Horde Rewards
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="https://horde.no/gjeldfri/horde-fondet"
                              color="secondary"
                              marginBottom={{ xs: "10px", md: "0px" }}
                            >
                              Horde-fondet
                            </Link>
                          </li>
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                </Stack>
                <Stack
                  gap={{ xs: "32px", md: "65px" }}
                  flexGrow={1}
                  flexShrink={1}
                  flexBasis="auto"
                >
                  <Stack
                    component="section"
                    paddingTop={{ xs: "35px", md: "0px" }}
                  >
                    <nav aria-labelledby="footer_legal">
                      <Typography variant="h4" id="footer_legal">
                        Nyheter
                      </Typography>
                      <ul>
                        <li>
                          <Link
                            color="secondary"
                            href="/artikler"
                            aria-current={currentPath === "/artikler"}
                          >
                            Artikler
                          </Link>
                        </li>
                        <li>
                          <Link
                            color="secondary"
                            href="/gjeldfri"
                            aria-current={currentPath === "/gjeldfri"}
                          >
                            Kampanjer
                          </Link>
                        </li>
                        <li>
                          <Link
                            color="secondary"
                            href="https://www.mynewsdesk.com/no/horde"
                            aria-current={
                              currentPath ===
                              "https://www.mynewsdesk.com/no/horde"
                            }
                          >
                            Presserom
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                  <Stack
                    component="section"
                    paddingTop={{ xs: "15px", md: "20px" }}
                  >
                    <nav aria-labelledby="footer_newSection">
                      <Typography
                        variant="h4"
                        id="footer_newSection"
                        whiteSpace="nowrap"
                      >
                        Horde Plus
                      </Typography>
                      <ul>
                        <li>
                          <Link
                            href="https://horde.plus/"
                            target="_blank"
                            rel="noreferrer"
                            color="secondary"
                            marginBottom={{ xs: "10px", md: "0px" }}
                          >
                            Horde Plus
                            <ArrowSquareOut />
                          </Link>
                          {/* <Typography>
                            Spar tid og penger
                            <br />
                            med AI-assistenter
                          </Typography> */}
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                  <Stack
                    component="section"
                    marginTop={{ xs: "0px", md: "-30px" }}
                  >
                    <nav aria-labelledby="footer_newSection">
                      <Typography
                        variant="h4"
                        id="footer_newSection"
                        whiteSpace="nowrap"
                      >
                        Forsikring
                      </Typography>
                      <ul>
                        <li>
                          <Link
                            href="https://horde.no/forsikring"
                            rel="noreferrer"
                            color="secondary"
                            marginBottom={{ xs: "10px", md: "0px" }}
                          >
                            Låneforsikring
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                </Stack>
                <Stack
                  gap={{ xs: "32px", md: "74px" }}
                  flexGrow={1}
                  flexShrink={1}
                  flexBasis="auto"
                >
                  <Stack
                    component="section"
                    paddingTop={{ xs: "35px", md: "0px" }}
                  >
                    <Typography variant="h4">Kontakt</Typography>
                    <address>
                      <Typography
                        variant="body1"
                        paddingTop={{ xs: "10px", md: "17px" }}
                      >
                        Horde AS
                      </Typography>
                      <Typography variant="body1">
                        Org. nr 921 695 322
                      </Typography>
                      <Typography variant="body1">
                        Lars Hilles gate 20A
                      </Typography>
                      <Typography variant="body1">5008 Bergen</Typography>
                      <Link
                        href="mailto:support@horde.no"
                        target="_blank"
                        rel="noreferrer"
                        color="secondary"
                      >
                        support@horde.no
                      </Link>
                    </address>
                  </Stack>
                  <Stack
                    component="section"
                    paddingTop={{ xs: "15px", md: "0px" }}
                  >
                    <nav aria-labelledby="footer_legal">
                      <Typography variant="h4" id="footer_legal">
                        Juridisk
                      </Typography>
                      <ul>
                        <li>
                          <Link
                            color="secondary"
                            href="/personvernerklaering"
                            aria-current={
                              currentPath === "/personvernerklaering"
                            }
                          >
                            Personvern og cookies
                          </Link>
                        </li>
                        <li>
                          <Link
                            color="secondary"
                            href="/ansvarlig-rapportering"
                            aria-current={
                              currentPath === "/ansvarlig-rapportering"
                            }
                          >
                            Ansvarlig rapportering
                          </Link>
                        </li>
                        <li>
                          <Link
                            color="secondary"
                            href="/vilkaar"
                            aria-current={currentPath === "/vilkaar"}
                            marginBottom={{ xs: "10px", md: "0px" }}
                          >
                            Brukervilkår
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                </Stack>
                <Stack
                  gap={{ xs: "32px", md: "53px" }}
                  flexGrow={1}
                  flexShrink={1}
                  flexBasis="auto"
                >
                  <Stack component="section">
                    <nav
                      aria-labelledby="footer_HordeSome"
                      className="someList"
                    >
                      <Typography
                        variant="h4"
                        id="footer_HordeSome"
                        pt={{ xs: "35px", md: "0px" }}
                      >
                        Følg Horde
                      </Typography>
                      <ul>
                        <li>
                          <Stack
                            direction="row"
                            paddingTop={{ xs: "0px", md: "8px" }}
                          >
                            <Link
                              href="https://www.tiktok.com/@horde.app"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <TikTokIcon />
                              TikTok
                            </Link>
                          </Stack>
                        </li>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://www.youtube.com/@hordeapp"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <YouTubeIcon />
                              YouTube
                            </Link>
                          </Stack>
                        </li>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://www.instagram.com/horde.no/"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <InstagramIcon />
                              Instagram
                            </Link>
                          </Stack>
                        </li>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://www.facebook.com/horde.no"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <FacebookIcon />
                              Facebook
                            </Link>
                          </Stack>
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                  <Stack
                    component="section"
                    paddingTop={{ xs: "15px", md: "0px" }}
                  >
                    <nav
                      aria-labelledby="footer_okonomiamatoreneSome"
                      className="someList"
                    >
                      <Typography variant="h4" id="footer_okonomiamatoreneSome">
                        Økonomiamatørene
                      </Typography>
                      <ul>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://open.spotify.com/show/6hfiE0nNyxBHM6iF06UimD"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <SpotifyIcon />
                              Spotify
                            </Link>
                          </Stack>
                        </li>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://www.youtube.com/@konomiamatrene"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <YouTubeIcon />
                              YouTube
                            </Link>
                          </Stack>
                        </li>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://podcasts.apple.com/us/podcast/%C3%B8konomiamat%C3%B8rene/id1521317377"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <ApplePodcast />
                              Apple Podcast
                            </Link>
                          </Stack>
                        </li>
                        <li>
                          <Stack direction="row">
                            <Link
                              href="https://podimo.com/no/shows/okonomiamatorene"
                              target="_blank"
                              rel="noreferrer"
                              className="someLink"
                              color="secondary"
                            >
                              <Podimo />
                              Podimo
                            </Link>
                          </Stack>
                        </li>
                      </ul>
                    </nav>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Stack direction={{ xs: "column", md: "row" }}>
              <Stack flex={0}>
                {/* <Button
                  variant="contained"
                  color="primary"
                  aria-label=""
                  type="submit"
                  sx={{
                    maxWidth: "230px",
                    marginRight: { xs: "0px", md: "360px" },
                    marginBottom: "29px",
                    marginTop: { xs: "20px", md: "0px" },
                    textDecoration: "none !important",
                    fontSize: "16px !important",
                    fontWeight: "600 !important",
                    "&:hover": {
                      backgroundColor: COLORS.BLACK[40], // Endre til ønsket hover-farge
                    },
                    "&:focus": {
                      borderRadius: "40px !important",
                    },
                  }}
                  href="https://web.horde.no/refinansiering/gjeldsregister"
                >
                  Søk refinansiering
                </Button> */}
                {/* <Typography
                  variant="body1"
                  sx={{
                    marginRight: { xs: "70px", md: "150px" },
                  }}
                >
                  Renteeksempel refinansiering: 135 000 kr over 8 år, effektiv
                  rente 14,73 %, kostnad 85 376 kr, totalt 220 376 kr,
                  nedbetalingstid 0-15 år.
                </Typography> */}
              </Stack>
              <Stack
                flexDirection={{ xs: "column-reverse", md: "column" }}
                gap={{ xs: "16px", md: "0px" }}
                paddingTop={{ xs: "34px", md: "0px" }}
              >
                <Stack flexDirection="row" gap="34px">
                  <Stack>
                    <a
                      href="https://www.finanstilsynet.no/virksomhetsregisteret/detalj/?id=211124"
                      target="_blank"
                      style={{ display: "inline-block", width: "100%" }}
                      rel="noreferrer"
                      aria-label="Finanstilsynet"
                    >
                      <FinansTilsynet width="100%" />
                    </a>
                  </Stack>
                  <Stack
                    flexDirection="row"
                    gap={{ xs: "14px", md: "0px" }}
                    pt="40px"
                  >
                    <a
                      href="https://www.finaut.no/"
                      target="_blank"
                      style={{
                        display: "inline-block",
                        width: "100%",
                        paddingTop: "6px",
                      }}
                      rel="noreferrer"
                      aria-label="Finaut"
                    >
                      <FinansAut width="100%" />
                    </a>
                  </Stack>
                </Stack>
                <Stack paddingTop="16px">
                  <Typography variant="body1">
                    Horde er låneformidler og betalingsforetak med konsesjon fra
                    <Link
                      href="https://www.finanstilsynet.no/virksomhetsregisteret/detalj/?id=211124"
                      color="secondary"
                      target="_blank"
                    >
                      Finanstilsynet.
                    </Link>
                  </Typography>
                  <Typography variant="body1">
                    Medlem av
                    <Link
                      href="https://www.finaut.no/"
                      color="secondary"
                      target="_blank"
                    >
                      Finaut.
                    </Link>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          {process.env.NODE_ENV === "development" && (
            <Typography color="pink">Dev mode</Typography>
          )}
        </Container>
      </footer>
    </ThemeProvider>
  );
};

export default HordePageFooter;
